import { render, staticRenderFns } from "./NewBusinessInvoice.vue?vue&type=template&id=de07b476&"
import script from "./NewBusinessInvoice.vue?vue&type=script&lang=js&"
export * from "./NewBusinessInvoice.vue?vue&type=script&lang=js&"
import style0 from "./NewBusinessInvoice.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports